import { canAccessAdmin } from "@services/user";
import i18n from "@libs/i18n";
import { Role, User } from "@gen/user/v1/user_pb";

export type MenuActionProps = {
  label: string;
  iconSrc: string;
  iconColor?: string;
  testId: string;
  action?: () => void;
  isVisible: boolean;
};

export const getMenuActions = (
  user: User,
  onLogout: () => void,
  onNavigate: (id: string) => void,
): MenuActionProps[] => {
  return [
    {
      label: i18n.t("profileMenu.account"),
      iconSrc: "user_4_fill",
      testId: "account-button",
      action: () => onNavigate("settings"),
      isVisible: true,
    },
    {
      label: i18n.t("profileMenu.bookings"),
      iconSrc: "coupon_line",
      testId: "bookings-button",
      action: () => onNavigate("bookings"),
      isVisible: true,
    },
    ...([Role.ADMIN, Role.TRAVEL_AGENT, Role.CAISSE_ASSOCIATE].includes(
      user.role,
    )
      ? [
          {
            label: i18n.t("admin.dapManagement"),
            iconSrc: "paper_line",
            testId: "agency-button",
            action: () => onNavigate("dap"),
            isVisible: canAccessAdmin(user),
          },
        ]
      : []),
    ...([Role.ADMIN, Role.TRAVEL_AGENT].includes(user.role)
      ? [
          {
            label: i18n.t("admin.user.userManagement"),
            iconSrc: "group_line",
            testId: "agency-button",
            action: () => onNavigate("user"),
            isVisible: canAccessAdmin(user),
          },
        ]
      : []),
    ...([Role.ADMIN, Role.TRAVEL_AGENT].includes(user.role)
      ? [
          {
            label: i18n.t("admin.agencyManagement"),
            iconSrc: "building_1_line",
            testId: "agency-button",
            action: () => onNavigate("agency"),
            isVisible: canAccessAdmin(user),
          },
        ]
      : []),
    ...([Role.ADMIN, Role.TRAVEL_AGENT, Role.CAISSE_ASSOCIATE].includes(
      user.role,
    )
      ? [
          {
            label: i18n.t("admin.caisseManagement"),
            iconSrc: "building_5_line",
            testId: "caisses-button",
            action: () => onNavigate("caisse"),
            isVisible: canAccessAdmin(user),
          },
        ]
      : []),

    {
      label: i18n.t("profileMenu.logout"),
      iconSrc: "align_arrow_right_line",
      testId: "logout-button",
      action: onLogout,
      isVisible: true,
    },
  ];
};
